import { useFeatureAccess } from "@/hooks/use-feature-access";
import { Feature } from "@/types/user";

export function useDemoAccess() {
  const { hasAccess } = useFeatureAccess();

  const isSystemAdmin = hasAccess("system_admin");

  // We'll keep the hasFeature function for backwards compatibility
  // and to allow checking for features not predefined in this hook
  const hasFeature = (feature: Feature) => hasAccess(feature);

  return {
    hasFeature,
    isSystemAdmin,
  };
}
